import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    GetAllCropTypes,
    GetAllJobsByOperationEntity,
    GetMappedJobsByCropType,
    SaveEstateJobMapping
};

async function GetAllCropTypes() {
    var cropTypeArray = [];
    const response = await CommonGet('/api/EstateJobMapping/GetAllCropTypes');
    for (let item of Object.entries(response.data)) {
        cropTypeArray[item[1]["cropTypeID"]] = item[1]["cropTypeName"]
    }
    return cropTypeArray;
}

async function GetAllJobsByOperationEntity(operationEntityID, cropTypeID) {
    const response = await CommonGet('/api/EstateJobMapping/GetAllJobsByOperationEntity',
        'operationEntityID=' + operationEntityID + '&cropTypeID=' + (cropTypeID || 0));
    return response.data;
}

async function GetMappedJobsByCropType(model) {
    const response = await CommonPost('/api/EstateJobMapping/GetMappedJobsByCropType', null, model);
    return response.data;
}

async function SaveEstateJobMapping(saveData) {
    const response = await CommonPost('/api/EstateJobMapping/SaveEstateJobMapping', null, saveData);
    return response;
}
